import axios from 'axios'
import TransitApiConfig from '../../../TransitOperationEditor/hooks/apiConfig'
import { TransitOperationReassignmentRequest } from '../../../../../api/models'

const { baseUrl } = TransitApiConfig.paths.transitOperation

async function reassignTransitOperation(data: TransitOperationReassignmentRequest) {
  return (await axios.post<void>(`${baseUrl}/reassign`, data)).data
}

export default reassignTransitOperation
